import variables from '../../styles/colors.module.scss';
import { INTERP } from '../shared/CommonConstants';

const { grayinter: grayInterp, white } = variables;
const { BELOW, PROFICIENT } = INTERP;
const DO_INTERP_COLOR_MAPPER = {
    [BELOW]: grayInterp,
    [PROFICIENT]: white,
};

export default DO_INTERP_COLOR_MAPPER;
